export default {
  methods: {
    async emitResizeMessage() {
      await this.$nextTick();
      const height = document.body.scrollHeight;
      window.parent.postMessage(['setHeight', height], '*');
    }
  }
};